import type { NDateLocale } from './enUS'
import { hi } from 'date-fns/locale'

const dateHiIN: NDateLocale = {
  name: 'hi-IN',
  locale: hi
}

export default dateHiIN
